import { ArrayQ } from "@pdfking/structs"

import type { AsyncSequence } from "#public"

import { Channel } from "../classes/Channel"
import { Map } from "../functions/Map"
import { Join } from "./Join"
import { ProcessIterable } from "./ProcessIterable"

// Starts draining the source eagerly, buffering items into a channel, so that
// multiple streams consumed sequentially still produce concurrently.
const preload = <T>(source: AsyncSequence<T>): AsyncSequence<T> => {
  if (ArrayQ(source)) return source
  const { push, stop, stream } = Channel<T>()
  void ProcessIterable(source, push, stop)
  return stream
}

export const Preload = <T>(...streams: AsyncSequence<T>[]): AsyncGenerator<T> =>
  Join(...Map(preload, streams))
